<template>
  <div
      @keydown.ctrl.s.prevent.stop="saveNoteKeyPressed"
      @keydown.meta.s.prevent.stop="saveNoteKeyPressed"
      @keydown.ctrl.n.prevent.stop="createNewNote"
      @keydown.meta.n.prevent.stop="createNewNote"
    >
      <!-- <button @click="writetodb">Add note</button> -->

      <div id="main" v-if="signedIn">
        
        <NotesList
          id="notes-list"
          v-on:save-note="saveNote()"
          v-on:open-confirmation-modal="openConfirmationModal"
        />
        <Note
          id="note"
          v-on:save-note="saveNote()"
          v-on:open-confirmation-modal="openConfirmationModal"
        />
      </div>

      <div v-if="!signedIn" style="height: 100vh;" />
    </div>
</template>

<script>
import { computed } from "vue";
import NotesList from "./NotesList.vue";
import Note from "./Note.vue";
import { saveData } from "../firebase-helpers.js";
import { defaultNote } from "../store";
import store from "../store";

export default {
  name: 'NotesMain',
  components: {
    NotesList,
    Note,
  },

  setup() {
    let signedIn = computed(function () {
      return store.state.user !== undefined && store.state.user !== null;
    });

    console.log(signedIn)

    return {
      signedIn,
    };
  },

  methods: {
    saveNoteKeyPressed(e) {
      console.log("save note key pressed");
      console.log(
        "store.state.activeNote === defaultNote",
        store.state.activeNote === defaultNote
      );

      if (!(e.keyCode === 83 && (e.ctrlKey || e.metaKey))) {
        return;
      }

      e.preventDefault();
      this.saveNote();
    },

    saveNote() {
      console.log("save note");
      store.state.activeNote.timestamp = Date.now();
      const noteIndex = store.state.notes.findIndex(
        (note) => note.id === store.state.activeNote.id
      );

      if (noteIndex < 0) {
        console.log("adding new note");
        store.commit("addNote", store.state.activeNote);
      } else {
        console.log("updating existing note");
        store.commit("updateNote", store.state.activeNote);
      }
      saveData("save");
    },

    openConfirmationModal(note) {
      this.$emit("open-confirmation-modal", note);
    },
  }
}
</script>

<style>

</style>